interface StepStripProps {
  step: number
  total?: number
  label: string
}

export function StepStrip({ step, total = 3, label }: StepStripProps) {
  const safeTotal = Math.max(total, 1)
  const pct = Math.min(100, Math.max(0, (step / safeTotal) * 100))

  return (
    <div className="mb-3.5 flex items-center gap-3 text-[11.5px] font-medium uppercase tracking-[0.04em] text-grey5">
      <span className="font-mono">
        0{step} / 0{safeTotal}
      </span>
      <div className="h-[2px] w-[60px] overflow-hidden rounded-sm bg-grey4">
        <div className="h-full bg-yellow1" style={{ width: `${pct}%` }} />
      </div>
      <span className="text-[12.5px] normal-case tracking-normal text-white">
        {label}
      </span>
    </div>
  )
}
